import type { AssignmentTarget } from 'utils/workout.helpers';

import type { ProgrammingNavState } from './types';

/** Back to the tab — and the athlete — the coach left from. */
export const programmingReturnState = (
  target: AssignmentTarget | undefined,
  date: string | undefined,
  view: 'week' | 'agenda',
): ProgrammingNavState => {
  if (target?.kind === 'athlete') return { view, date, tab: 'athletes', athleteId: target.id };

  return { view, date, tab: 'classes' };
};
